import React from "react";
import "./home.css";

import heroShot from "../assets/images/heroShot.jpg";
import procGen from "../assets/images/ProcGen.gif";
import mazeGen from "../assets/images/MazeGen.gif";
import website from "../assets/images/Website.png";

function Home() {
  return (
    <section className="home-section">
      <div className="home-container">

        {/* Hero Section */}
        <div className="hero">
          <div className="hero-text">
            <h1>Zack Olson</h1>
            <h2>Software and Game Programmer</h2>
            <p>I'm a computer science student who loves to create things and solve problems</p>
            <div className="hero-buttons">
              <a href="/about" className="hero-btn">About Me</a>
              <a href="/projects" className="hero-btn">See My Work</a>
            </div>
          </div>
          <div className="hero-image">
            <img src={heroShot} alt="Zack Olson" />
          </div>
        </div>

        {/* Skills Snapshot */}
        <div className="skills-snapshot">
          <h3>Top Skills</h3>
          <div className="skills-grid">
            <div className="skill-item">Unity Engine</div>
            <div className="skill-item">C++</div>
            <div className="skill-item">Web Development</div>
            <div className="skill-item">Google and Microsoft Suite</div>
            <div className="skill-item">Problem Solving</div>
          </div>
        </div>

        {/* Featured Projects Teaser */}
        <div className="featured-projects">
          <h3>Featured Projects</h3>
          <div className="projects-grid">
            <div className="project-card">
              <img src={website} alt="Website" />
              <h4>This Website!</h4>
              <p>The website before your very eyes</p>
            </div>
            <div className="project-card">
              <img src={procGen} alt="Infinite Terrain" />
              <h4>Procedual Terrain</h4>
              <p>A unity based terrain generator that create infinite procedual terrain</p>
            </div>
            <div className="project-card">
              <img src={mazeGen} alt="MazeGen" />
              <h4>Random Maze Generator</h4>
              <p>A unity and C++ project using pathfinding to create a random maze</p>
            </div>
          </div>
        </div>

        {/* Quick Contact */}
        <div className="home-contact">
          <h3>Get In Touch</h3>
          <p>Email: <a href="mailto:ZacharyOlsonOnline@gmail.com">ZacharyOlsonOnline@gmail.com</a></p>
          <p>LinkedIn: <a href="https://www.linkedin.com/in/zack-o-olson/" target="_blank" rel="noopener noreferrer">Zack Olson</a></p>
          <p>GitHub: <a href="https://github.com/ZackOlson" target="_blank" rel="noopener noreferrer">ZackOlson</a></p>
        </div>

      </div>
    </section>
  );
}

export default Home;